import { number } from "prop-types";

import styled from "styled-components/macro";

import FnrTypography from "FnrTypography";
import { useChildren } from "HouseholdProfile/API/queryHooks";
import { HouseholdProfileProvider } from "HouseholdProfile/HouseholdProfile";
import { motion } from "framer-motion";

import FnrDivider from "UI/FnrDivider";
import FnrStaggeredEntry from "UI/FnrStaggeredEntry";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap";
import { scrollbarInvisibleThin } from "UI/scrollbarStyles";

import useIsMobile from "Utilities/Hooks/useIsMobile";

import Dependants from "../Dependents/Dependents";
import Hohs from "../Hohs";

const Wrapper = styled(motion.div)`
  ${scrollbarInvisibleThin}
  scrollbar-width: none;
  overflow-y: auto;
  padding-bottom: 16px;

  @media screen and (max-width: 680px) {
    margin-top: 4px;
  }
`;

const TopMobileFnrDivider = styled(FnrDivider)`
  width: calc(100% - 18px);
  margin-inline: 8px;
  margin-block: 4px 7px;
  display: none;

  @media screen and (max-width: 680px) {
    display: block;
  }
`;

const SFnrDivider = styled(FnrDivider)`
  width: calc(100% - 2px);
  margin-inline-end: 2px;
`;

const SFnrHorizontalGap = styled(FnrHorizontalGap)`
  margin-inline: 8px;
  margin-block: 1px 0;

  @media screen and (max-width: 680px) {
    margin-block: 4px 12px;
  }
`;

const HouseholdMembersContents = () => {
  const children = useChildren();
  const hasChildren = children.length > 0;

  const isMobile = useIsMobile(680);

  return (
    <Wrapper>
      <TopMobileFnrDivider color="faintTaupe" thickness={2} />
      <FnrVerticalGap gap={isMobile ? 0 : undefined}>
        <Hohs />
        <FnrStaggeredEntry show={hasChildren} muted={isMobile}>
          <SFnrHorizontalGap fullWidth gap={4}>
            <FnrTypography fontSize="xs" color="taupe">
              CHILDREN
            </FnrTypography>
            <SFnrDivider color="faintTaupe" thickness={2} />
          </SFnrHorizontalGap>
        </FnrStaggeredEntry>
        <Dependants />
      </FnrVerticalGap>
    </Wrapper>
  );
};

const HouseholdMembers = ({ householdID }) => (
  <HouseholdProfileProvider householdID={householdID}>
    <HouseholdMembersContents />
  </HouseholdProfileProvider>
);

HouseholdMembers.propTypes = { householdID: number };

export default HouseholdMembers;
